import create from 'zustand'

type Store = {
  uploadedFileIds: string[]
  setUploadedFileIds: (uploadedFileIds: string[]) => void
  resetUploadedFileIds: () => void
}

export const useFileUploadStore = create<Store>((set) => ({
  uploadedFileIds: [],
  setUploadedFileIds: (uploadedFileIds: string[]) =>
    set((state) => ({
      uploadedFileIds: [...state.uploadedFileIds, ...uploadedFileIds],
    })),
  resetUploadedFileIds: () => set({ uploadedFileIds: [] }),
}))
